import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Pagination from 'react-paginate';

import ConsultantSearchCard from '../ConsultantSearchCard';
import NoSearchResults from './NoSearchResults';
import LoadingIndicator from './LoadingSearchIndicator';

class SearchResultContainer extends PureComponent {
  constructor(props) {
    super(props);

    this.renderConsultantCards = this.renderConsultantCards.bind(this);
    this.handlePageClick = this.handlePageClick.bind(this);
  }

  handlePageClick({ selected }) {
    const { setCurrentPage } = this.props;
    setCurrentPage(selected + 1);
  }

  renderConsultantCards() {
    const {
      consultants,
      location,
      csrfToken,
      workLocationOptions,
      durationOptions,
      timePerWeekOptions,
      query,
      inviteUrl,
      inviterEmailDomain,
      viewingAsEmployer,
    } = this.props;

    return consultants.map((consultant) => (
      <ConsultantSearchCard
        key={consultant.id}
        consultant={consultant}
        location={location}
        csrfToken={csrfToken}
        workLocationOptions={workLocationOptions}
        durationOptions={durationOptions}
        timePerWeekOptions={timePerWeekOptions}
        query={query}
        inviteUrl={inviteUrl}
        inviterEmailDomain={inviterEmailDomain}
        viewingAsEmployer={viewingAsEmployer}
      />
    ));
  }

  render() {
    const {
      loading,
      consultants,
      currentPage,
      csrfToken,
      totalPages,
    } = this.props;

    if (loading) {
      return (
        <LoadingIndicator />
      );
    }

    if (consultants.length > 0) {
      return (
        <div>
          {this.renderConsultantCards()}
          {totalPages > 1
            && (
            <Pagination
              previousLabel={(
                <div>
                  <i className="fa fa-chevron-left" />
&nbsp;&nbsp;Prev
                </div>
)}
              nextLabel={(
                <div>
                  Next&nbsp;&nbsp;
                  <i className="fa fa-chevron-right" />
                </div>
)}
              breakLabel="..."
              breakClassName="break-me"
              currentPage={currentPage}
              pageCount={totalPages}
              onPageChange={this.handlePageClick}
              containerClassName="pagination"
              activeClassName="active"
              marginPagesDisplayed={1}
            />
            )}
        </div>
      );
    }

    return (
      <NoSearchResults
        csrfToken={csrfToken}
      />
    );
  }
}

SearchResultContainer.propTypes = {
  loading: PropTypes.bool.isRequired,
  consultants: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  setCurrentPage: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  csrfToken: PropTypes.string.isRequired,
  workLocationOptions: PropTypes.shape({}).isRequired,
  durationOptions: PropTypes.oneOfType([PropTypes.shape({}),
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string]))]).isRequired,
  timePerWeekOptions: PropTypes.oneOfType([PropTypes.shape({}),
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string]))]).isRequired,
  query: PropTypes.number,
  inviteUrl: PropTypes.string.isRequired,
  inviterEmailDomain: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  viewingAsEmployer: PropTypes.bool,
  totalPages: PropTypes.number.isRequired,
};

SearchResultContainer.defaultProps = {
  query: '',
  viewingAsEmployer: true,
};

export default SearchResultContainer;
